// Pure: given the authoritative instance row and my user id, decide HOW a
// "discard / leave" action must reach the server. No side effects, no network.
//
// The trap this fixes: a draft/sealed instance linked to a draft_event owns
// its exits (refunds, pod management) in the draft_events system. The plain
// instance /leave route rejects such rows with a 409 ("leave drafts via the
// draft event"), so a non-creator who tries to leave a never-started draft via
// Your Matches gets an error and is stuck. The keystone escrow stays held.
// A non-creator on a linked draft/sealed instance must call the draft-event
// leave (which releases the held escrow) instead.
//
// Returns one of:
//   { kind: 'abandonInstance' }. Creator: /instances/:id/abandon
//                                            (server cascades the draft abort)
//   { kind: 'leaveDraftEvent', eventId }. Non-creator on a linked
//                                            draft/sealed lobby: leave via the
//                                            draft event so the escrow refunds
//   { kind: 'leaveInstance' }. Non-creator otherwise: plain
//                                            /instances/:id/leave

export function resolveDiscardLeave(instance, myId) {
  const me = (instance?.participants || []).find((p) => p.userId === myId);
  const isHost = me?.role === 'creator';
  if (isHost) return { kind: 'abandonInstance' };

  const isDraftMode = instance?.mode === 'draft' || instance?.mode === 'sealed';
  const eventId = instance?.draft_event_id;
  if (isDraftMode && eventId) {
    return { kind: 'leaveDraftEvent', eventId };
  }
  return { kind: 'leaveInstance' };
}
